import { useEffect, useRef, useState } from "react";
import store from "../../../../store";
import { actions } from "react-redux-form";

const CustomSearchableDropdown = (props) => {
    const { label, labelRight, options = [], optionLabelKey, selected, value, placeholder, requiredField, isError, name, disabled = false, displayOption,
        maxLength, isMainFilter, isNullable, customClass, onChange, tagName, fieldProp, onBlurHandler, onLoadMore, hasMore, isLoading, onSearchChange, hasTilde, isRequiredButNullable } = props;
    const [inputValue, setInputValue] = useState("");
    const [showOptions, setShowOptions] = useState(false);
    const [modifiedOptions, setModifiedOptions] = useState([]);
    const wrapperRef = useRef(null);
    const inputValueRef = useRef("");
    const firstLoad = useRef(true);
    const lastValidValueRef = useRef("");

    useEffect(() => {
        const isInputFocused = document.activeElement === inputValueRef.current;

        if (!isInputFocused) {
            if (selected !== null && selected !== undefined && selected !== "" && selected !== 0) {
                lastValidValueRef.current = selectedValue(selected);
                if (lastValidValueRef.current) {
                    setInputValue(lastValidValueRef.current);
                }
            } else {
                if (!requiredField) {
                    setInputValue("");
                }
            }
        }
    }, [selected, options]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShowOptions(false);

                const inputVal = inputValueRef.current?.value || "";
                const isInvalid = modifiedOptions.findIndex(o => o.Value === inputVal) === -1;

                if (requiredField && (inputVal === "" || isInvalid)) {
                    setInputValue(lastValidValueRef.current || "");
                    setModifiedOptions(transformOptions(options));
                    if (isNullable && typeof onChange === "function") {
                        onChange(lastValidValueRef.current);
                    }
                    return;
                }

                if (inputVal === "") {
                    setInputValue("");
                    setModifiedOptions(transformOptions(options));
                    if (isNullable && typeof onChange === "function") {
                        onChange(null);
                    }
                    if (isMainFilter === true) {
                        handleOptionClick(options);
                    }
                    return;
                }

                if (inputVal !== "" && isInvalid) {
                    setInputValue("");
                    setModifiedOptions([]);
                    if (isNullable) {
                        handleSearchChange({ target: { value: "" } });
                    }
                    if (isMainFilter === true) {
                        handleOptionClick(options);
                    }
                }
            } else {
                if (inputValueRef.current && inputValueRef.current.value === "" && !selected) {
                    const selectedOption = modifiedOptions.find(opt => opt.Key === value);
                    const correctDisplayText = selectedOption ? selectedOption.Value : '';
                    setInputValue(correctDisplayText);
                }
            }
        };

        if (showOptions) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showOptions, selected, modifiedOptions, options, requiredField, isMainFilter, isNullable, name]);

    useEffect(() => {
        if (options.length > 0 && fieldProp !== "inventoryCicuitPlanDetailsForm.PlanId") {
            setModifiedOptions(transformOptions(options));
        }
        else if (options.length >= 0 && fieldProp === "inventoryCicuitPlanDetailsForm.PlanId") {
            setModifiedOptions(transformOptions(options));
        }
    }, [options, fieldProp]);

    useEffect(() => {
        if (!onSearchChange) return;
        if (firstLoad.current) {
            firstLoad.current = false;
            return;
        }

        const value = inputValue ?? ""; 

        if (value.trim() === "") {
            onSearchChange(null);
        }


        const timeout = setTimeout(() => {
            onSearchChange(value);
        }, 300);
        return () => clearTimeout(timeout);

        
    }, [inputValue]);

    useEffect(() => {
        // Always update modifiedOptions when options change
        setModifiedOptions(transformOptions(options));
    }, [options]);

    useEffect(() => {
        document.addEventListener("keydown", handleOnBlur);
        return () => {
            document.removeEventListener("keydown", handleOnBlur);
        };
    });

    const transformOptions = (options = []) => {
        if (options === null || options === undefined || !Array.isArray(options)) {
            return [];
        }
        return options.map((option) => ({
            Key: option[optionLabelKey?.Key],
            Value: option[optionLabelKey?.Value],
            Label: option[optionLabelKey?.Label],
            CustomData: option[optionLabelKey?.CustomData]
        }));
    };

    const handleSearchChange = (e) => {
        const value = e.target.value;
        //setInputValue(value);

        if (value === "") {
            setModifiedOptions(transformOptions(options));
            if (!requiredField) {
                store.dispatch(actions.change(name, ""));
                store.dispatch(actions.change(fieldProp, ""));
            }
            if (isNullable && typeof onChange === "function") {
                onChange(null);
            }
        } else {
            const filtered = transformOptions(options).filter(
                (opt) =>
                    opt.Label?.toLowerCase().includes(value.toLowerCase()) ||
                    opt.Value?.toLowerCase().includes(value.toLowerCase())
            );
            setModifiedOptions(filtered.length > 0 ? filtered : []);
        }
        setInputValue(value);
    };

    const handleOnBlur = (event) => {
        const acceptedEvent = event.code === "Tab" || event.type === "blur";
        if (
            modifiedOptions.findIndex((o) => o.Value === inputValue) === -1 &&
            !showOptions &&
            acceptedEvent
        ) {
            if (!requiredField) {
                store.dispatch(actions.change(name, ""));
                store.dispatch(actions.change(fieldProp, ""));
            }
            if (onBlurHandler) {
                onBlurHandler();
            }
        }
    };

    const handleOptionClick = (option) => {
        setShowOptions(false);

        const valObj = {
            target: { tagName: tagName || "SEARCHABLE-SELECT" },
            value: option.Value,
            text: option.Value,
            key: option.Key,
            label: option.Label,
            customData: option.CustomData
        };

        lastValidValueRef.current = valObj.value;

        if (typeof onChange === "function") {
            if (tagName === "SEARCHABLE-SELECT") {
                onChange(valObj);
                store.dispatch(actions.change(name, valObj.key));
            } else {
                onChange(valObj.key);
                store.dispatch(actions.change(name, valObj.key));
            }
        }

        let finalValue = valObj.value;
        if (valObj.value?.includes("~") && !hasTilde) {
            finalValue = valObj.value.split("~")[0].trim();
        }

        setInputValue(finalValue);
    };

    const handleScroll = (event) => {
        const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
        if (scrollHeight - scrollTop <= clientHeight + 20) {
            if (hasMore && !isLoading && onLoadMore) {
                onLoadMore(inputValue);
            }
        }
    };

    const selectedValue = (Key) => {
        if (!Key) return "";
        const transOptions = displayOption ? options : transformOptions(options);
        const result =
            name === "inventoryCircuitEquipForm.ModelId"
                ? transOptions.find((option) => option.Key === Key.toString())
                : transOptions.find((option) => option.Key === Key);

        if (result?.Value?.includes("~") && !hasTilde) {
            const valueBeforeTilde = result.Value.split("~")[0].trim();
            return valueBeforeTilde;
        } else {
            return displayOption ? (result?.Label || "") : (result?.Value || "");
        }
    };

    return (
        <div ref={wrapperRef} className={`custom-select-wrapper ${customClass} ${!label && 'icon-recenter'} ${(requiredField || isRequiredButNullable) ? "required" : ""} ${disabled ? "disabled" : ""} ${isError ? "border-red" : ""} ${showOptions ? "border-blue" : ""}`}>
            {label && (
                <div className={labelRight ? "ask-ai-enabled custom-select-label-row" : "custom-select-label-row"}>
                    <div className="custom-select-label">{label}</div>
                    {labelRight ? <div className="custom-select-label-right">{labelRight}</div> : null}
                </div>
            )}
            <input
                className={`${disabled ? "custom-select-input disabled" : "custom-select-input"} mb-0 form-select`}
                type="text"
                placeholder={placeholder}
                value={inputValue || ""}
                onChange={handleSearchChange}
                onFocus={() => setShowOptions(true)}
                onBlur={handleOnBlur}
                disabled={disabled}
                ref={inputValueRef}
                maxLength={maxLength}
            />
            {showOptions && modifiedOptions.length > 0 && (
                <ul className="custom-select-options" onScroll={handleScroll}>
                    {modifiedOptions.map((option, index) => (
                        <li
                            key={index}
                            onClick={() => handleOptionClick(option)}
                            className="custom-select-option"
                        >
                            {option.CustomData ? option.CustomData : option.Value}
                        </li>
                    ))}
                    {isLoading && <li className="custom-select-option-loading">Loading...</li>}
                </ul>
            )}
        </div>
    );
};

export default CustomSearchableDropdown;